import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "solution-wrap" }
const _hoisted_2 = { class: "solution-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "solution-content" }
const _hoisted_5 = { class: "solution-box" }
const _hoisted_6 = { class: "solution-tab" }
const _hoisted_7 = ["onClick"]

import { ref, reactive, onMounted, watch } from 'vue'
import MetaverseView from '@/components/mobile/MetaverseView.vue';
import VRSimulation from '@/components/mobile/VRSimulation.vue';
import NavigationGuide from '@/components/mobile/NavigationGuide.vue';
import VirtualMuseum from '@/components/mobile/VirtualMuseum.vue';
import ArWechat from '@/components/mobile/ArWechat.vue';
import router from '@/router';
import store from '@/store';
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'SolutionView2',
  setup(__props) {

const loadUrl: any = ref({})

const solutionList = ['VR虚拟仿真', 'AR导航导览', 'AR小程序', '元宇宙展厅', '虚拟博物馆']
const activeSolutionIndex = ref(-1)

const handleClickEvent = (index: number, item: string) => {
  store.state.programmeIndex = index
  router.push(`/solution2?type=${index}&pathName=解决方案,${item}`)
}

onMounted(async () => {
  const query: any = router.currentRoute.value.query;
  activeSolutionIndex.value = query?.type || 0

  const jjfa_bg: any = await asynchronousRetrieval('webimg/images/solution/jjfa_bg.png');
  loadUrl.value = { jjfa_bg }
})

watch(store.state, (newState) => {
  if (newState.programmeIndex != activeSolutionIndex.value) {
    activeSolutionIndex.value = newState.programmeIndex
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", null, [
        _createElementVNode("span", null, "数实融合"),
        _createElementVNode("span", null, "虚实互生")
      ], -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", null, "共同推动产业创新融合发展", -1)),
      _createElementVNode("img", {
        src: loadUrl.value.jjfa_bg
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(solutionList, (item, index) => {
              return _createElementVNode("div", {
                key: index,
                class: _normalizeClass(activeSolutionIndex.value == index ? 'active' : ''),
                onClick: ($event: any) => (handleClickEvent(index, item))
              }, _toDisplayString(item), 11, _hoisted_7)
            }), 64))
          ])
        ]),
        (activeSolutionIndex.value == 0)
          ? (_openBlock(), _createBlock(VRSimulation, { key: 0 }))
          : _createCommentVNode("", true),
        (activeSolutionIndex.value == 1)
          ? (_openBlock(), _createBlock(NavigationGuide, { key: 1 }))
          : _createCommentVNode("", true),
        (activeSolutionIndex.value == 2)
          ? (_openBlock(), _createBlock(ArWechat, { key: 2 }))
          : _createCommentVNode("", true),
        (activeSolutionIndex.value == 3)
          ? (_openBlock(), _createBlock(MetaverseView, { key: 3 }))
          : _createCommentVNode("", true),
        (activeSolutionIndex.value == 4)
          ? (_openBlock(), _createBlock(VirtualMuseum, { key: 4 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})